/**
 * Where the console pulls helmet video from.
 *
 * Straight off the broker as a chunked `video/mp4` body — the same shape `RtspVideoPlayer` already
 * consumes for RTSP cameras. There is no signalling step and no media server, so this is the entire
 * client side of playback.
 */

/**
 * Derive the broker's HTTP origin from the websocket URL the console already holds.
 *
 * Deliberately no second config key: the stream route is served by the same process on the same
 * host as the websocket, and two keys could disagree — a failure that presents as a socket which
 * connects while video never arrives.
 */
export function brokerHttpOrigin(liveChannelUrl: string): string | null {
  try {
    const url = new URL(liveChannelUrl)

    if (url.protocol !== 'ws:' && url.protocol !== 'wss:') return null

    return `${url.protocol === 'wss:' ? 'https:' : 'http:'}//${url.host}`
  } catch {
    return null
  }
}

/**
 * The robot-addressed stream URL.
 *
 * Addressed by ROBOT, not by stream: the console knows which helmet it is watching but not which
 * session, and shipping a session id to the browser only to have it sent back would be a round trip
 * whose sole purpose is to let the two disagree.
 */
export function helmetStreamUrl(origin: string, robotId: string): string {
  return `${origin.replace(/\/+$/, '')}/helmet/stream/robot/${encodeURIComponent(robotId)}.mp4`
}
